import { render, staticRenderFns } from "./PoliciesIndex.vue?vue&type=template&id=bbb57892&"
import script from "./PoliciesIndex.vue?vue&type=script&lang=js&"
export * from "./PoliciesIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports